import type { CompatRouter as NextRouter } from "@/hooks/useCompatRouter";
import { CSSProperties } from "react";
import { getS3ImageUrl, homePageRoutePath } from "./routes";

import Cookies from "js-cookie";
import { cartButtonId, envs, productImageId, routes } from "./constants";

import { markerYOffset } from "@/utils/constants";
import { getRedirectUrl } from "@/requests/page";
import { upperFirst } from "@mantine/hooks";
import { ClassValue, clsx } from "clsx";
import { GetServerSidePropsContext, PreviewData } from "next";
import { ParsedUrlQuery } from "querystring";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";
import { jwtDecode as _jwtDecode } from "jwt-decode";
export const jwtDecode = _jwtDecode;


export function devideArray<T>(array: T[], size: number): T[][] {
	const result: T[][] = [];
	for (let i = 0; i < array.length; i += size) {
		result.push(array.slice(i, i + size));
	}
	return result;
}


export const toDayHrMinSec = (time: number, type: "sm" | "lg" = "sm") => {
	let cd = 24 * 60 * 60 * 1000,
		day = Math.floor(time / cd),
		pad = function (n: number) {
			return n < 10 ? "0" + n : n;
		};

	let seconds = Math.floor(time / 1000);
	let minutes = Math.floor(seconds / 60);
	let hours = Math.floor(minutes / 60);

	seconds = seconds % 60;
	minutes = minutes % 60;

	// 👇️ If you don't want to roll hours over, e.g. 24 to 00
	// 👇️ comment (or remove) the line below
	// commenting next line gets you `24:00:00` instead of `00:00:00`
	// or `36:15:31` instead of `12:15:31`, etc.
	hours = hours % 24;

	// if (day > 0 && type === 'sm')
	//     return [day + 'd', pad(hours) + 'h', pad(minutes) + 'm'];
	if (day > 0)
		return [
			day + "d",
			pad(hours) + "h",
			pad(minutes) + "m",
			pad(seconds) + "s",
		];
	else return [pad(hours) + "h", pad(minutes) + "m", pad(seconds) + "s"];
};

/**
 * @useCase to get two digit number
 * @param num - number
 * @returns string
 * @author Azher Uddin <https://github.com/AzherUddin617>
 * @date 2022-08-17 10:03:06
 */
export const toTwoDigit = (num: number) => {
	return num < 10 ? `0${num}` : num + "";
};

export const toLoginPage = (router: NextRouter, redirectPath?: string) => {
	let backPath = globalThis?.btoa?.(
		redirectPath ? "" + redirectPath : router.asPath
	);

	if (router.pathname.match("/auth/")) {
		if (!!router.query.back) {
			router.push(
				homePageRoutePath +
					routes.otpLogin +
					"?back=" +
					router.query.back
			);
		} else {
			router.push(homePageRoutePath);
		}
	} else {
		router.push(homePageRoutePath + routes.otpLogin + "?back=" + backPath);
	}
};

export const depcryptString = (str?: string) => {
	if (!str) return "";
	return globalThis?.atob?.(str);
};

export const encryptString = (str?: string) => {
	if (!str) return "";
	return globalThis?.btoa?.(str);
};

export const toBackPath = (router: NextRouter) => {
	const backPath = router.query.back as string;
	if (backPath && !!globalThis) {
		const path = globalThis?.atob?.(backPath);
		router.push(path || homePageRoutePath);
	} else {
		router.push(homePageRoutePath);
	}
};

// export const isCartItemExist = (cartData: CartInitShop[], productId: ProductIdType, sku: string) => {
//   cartData.forEach(data => {

//     if (data.products?.find(item => item.id === productId && item.sku === sku)) {
//       return true;
//     }
//   })

//   return false;
// }

// export const isWishlistItemExist = (wishlistData: CartDataType[], productId: ProductIdType) => {
//   return !!wishlistData.find(cartItem => cartItem.id === productId);
// }

export const checkDummyImageUrl = (url: string) => {
	if (url.match(/http/) && url.match(/s3.ap-southeast-1/i)) {
		return url;
	} else if (url.match(/http/)) {
		return "";
	} else {
		return process.env.NEXT_PUBLIC_S3_BASE_URL + url;
	}
};

export const getDateWithTime = (date: Date) => {
	const day = date.getDate();
	const month = date.getMonth();
	const year = date.getFullYear();
	const time = [date.getHours(), date.getMinutes()].join(":");
	return [month, day, year].join("-") + " " + time;
};

export const toastMe = (
	message: string | any,
	type: "success" | "error" | "warning" | "info" = "success",
	extraMsg = ""
): void => {
	if (typeof message === "string") {
		toast(message, {
			position: "bottom-right",
			autoClose: 2000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
			type: type,
		});
	} else if (!!message && typeof message === "object") {
		const messages = findErrorMessages(message);
		messages.forEach((msg) => {
			toastMe(msg, "error");
		});

		// const obj = message?.response?.data.error || {}
		// const keys = objectKeysTS(obj)

		// keys.forEach(key => {
		//     if (!Array.isArray(obj[key])) return;

		//   obj[key]?.forEach((msg: string) => {
		//     toastMe(msg, 'error')
		//   })
		// })
	} else {
		toastMe(extraMsg || "Something went wrong", type);
	}
};

export const findErrorMessages = (error: any) => {
	const errorMessages: string[] = [];
	if (
		typeof error?.response?.data?.error === "object" &&
		(Array.isArray(error?.response?.data?.error)
			? !!error?.response?.data?.error?.length
			: Object.keys(error?.response?.data?.error).length)
	) {
		const errorObj = error.response.data.error;
		for (const key in errorObj) {
			errorObj[key]?.forEach((msg: string) => {
				if (typeof msg === "string") errorMessages.push(msg);
			});
		}
	}

	const responseMessage =
		error?.response?.data?.message || error?.response?.data?.Message;
	if (
		(error?.response?.data?.statusCode || error?.response?.data?.code) <
			450 &&
		responseMessage &&
		errorMessages.length === 0
	) {
		errorMessages.push(responseMessage);
	}

	if (errorMessages.length === 0) {
		const fallbackMessage = error?.Message || error?.message;
		if (fallbackMessage) errorMessages.push(fallbackMessage);
	}

	return errorMessages;
};

export const findErrorMessagesCopy = (error: any) => {
	const errorMessages: string[] = [];
	if (
		typeof error?.response?.data?.message === "object" &&
		(Array.isArray(error?.response?.data?.message)
			? !!error?.response?.data?.message?.length
			: Object.keys(error?.response?.data?.message).length)
	) {
		const errorObj = error.response.data.message;
		for (const key in errorObj) {
			errorObj[key]?.forEach((msg: string) => {
				if (typeof msg === "string") errorMessages.push(msg);
			});
		}
	}

	const responseMessage =
		error?.response?.data?.message || error?.response?.data?.Message;
	// if (
	// 	(error?.response?.data?.statusCode || error?.response?.data?.code) <
	// 		450 &&
	// 	responseMessage &&
	// 	errorMessages.length === 0
	// ) {
	// 	errorMessages.push(responseMessage);
	// }

	// if (errorMessages.length === 0) {
	// 	const fallbackMessage = error?.Message || error?.message;
	// 	if (fallbackMessage) errorMessages.push(fallbackMessage);
	// }
	errorMessages.push(responseMessage);

	return errorMessages;
};

export const objectToString = (obj: any) => {
	let str = "";
	for (const key in obj) {
		str += `${upperFirst(key)}: ${obj[key]}\n`;
	}
	return str.slice(0, -1);
};

export const splitName = (name?: string) => {
	if (!name)
		return {
			firstName: "",
			lastName: "",
		};

	const splitName = name?.trim()?.split(" ") || [];
	const firstName =
		splitName.length > 1
			? splitName.slice(0, -1).join(" ")
			: splitName.join("");
	const lastName =
		splitName.length > 1 ? splitName[splitName.length - 1] : "";

	return {
		firstName,
		lastName,
	};
};

export const fullName = (firstName?: string, lastName?: string) => {
	if (!firstName && !lastName) return "";

	return `${firstName || ""} ${lastName || ""}`.trim();
};

export const getDiscount = (prev?: number, curr?: number): number => {
	if (prev && curr && prev > curr) {
		const discount = ((prev - curr) / prev) * 100;
		return Math.round(+discount);
	} else return 0;
};

export const removeZone = (date: string) => {
	return date.endsWith("Z") ? date.slice(0, -1) : date;
};

// sweetalert2 is ~45KB gzipped — loaded on demand instead of in every
// page bundle (utils/index.ts is imported by nearly every client view)
const loadSwal = () => import("sweetalert2").then((m) => m.default);

export const deleteWarningPopup = async (): Promise<boolean> => {
	const Swal = await loadSwal();
	return new Promise((resolve, reject) => {
		Swal.fire({
			text: "Are you sure you want to remove?",
			icon: "warning",
			showCancelButton: true,
			cancelButtonColor: "#EB5525",
			confirmButtonColor: "gray",
			confirmButtonText: "Remove",
		})
			.then((result) => {
				if (result.isConfirmed) {
					resolve(true);
				}
			})
			.catch((reason) => {
				reject(false);
			});
	});
};

export const confirmPopup = ({
	message,
	icon = "success",
	confirmButtonText,
}: {
	message: string;
	icon?: "warning" | "error" | "success" | "info" | "question";
	confirmButtonText: string;
}): Promise<boolean> => {
	return loadSwal().then((Swal) => new Promise((resolve, reject) => {
		Swal.fire({
			text: message,
			icon: icon,
			showCancelButton: true,
			cancelButtonColor: "gray",
			confirmButtonColor: "#EB5525",
			confirmButtonText: confirmButtonText,
		})
			.then((result) => {
				if (result.isConfirmed) {
					resolve(true);
				}
			})
			.catch((reason) => {
				reject(false);
			});
	}));
};

export const getProductPrice = (
	discountedPrice?: number | string,
	price?: number | string
) => {
	const dPrice = +(discountedPrice || "0");
	const uPrice = +(price || "0");

	return {
		price: dPrice && dPrice > 0 ? dPrice : uPrice,
		prevPrice: dPrice && dPrice > 0 && dPrice < uPrice ? uPrice : dPrice,
	};
};

export const isOutOfStock = (
	availableQuantity: number,
	minQuantity: number
) => {
	if (availableQuantity <= 0) return true;

	if (availableQuantity < minQuantity) return true;

	return false;
};

export const convertUTC0toDhaka = (date: string | Date) => {
	const dateTime = new Date(date).getTime() + 6 * 60 * 60 * 1000;
	return new Date(date);
};

export function numberWithCommas(price: number) {
	return new Intl.NumberFormat("en-IN", { currency: "BDT" }).format(price);
}

export const toDubleDigit = (num: number) => (num < 10 ? "0" + num : "" + num);

export const objectKeysTS = <T extends object>(obj: T) =>
	Object.keys(obj) as (keyof T)[];

export const isBangladeshiPhoneNumber = (phone: string) => {
	const regex = /^(?:(?:\+|00)88|01)?\d{11}$/;
	return regex.test(phone);
};

export const isBrandToHide = (brandName: string, id?: number) => {
	// if (id && id === 278) return false;
	if (!brandName) return true;
	if (brandName.toLowerCase() === "n/a") return true;
	if (
		brandName.toLocaleLowerCase() === "other" ||
		brandName.toLocaleLowerCase() === "others"
	)
		return true;
	if (brandName.toLocaleLowerCase() === "no brand") return true;
	return false;
};

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const getSectionStyle = (settings?: any) => {
	// WidgetSettings
	const style: CSSProperties = {
		backgroundColor: settings?.bgColor || undefined,
		backgroundImage: settings?.bgImage
			? `url(${getS3ImageUrl(settings?.bgImage)})`
			: undefined,
		backgroundSize: settings?.bgSize || undefined,
		backgroundPosition: settings?.bgPosition || undefined,
		backgroundRepeat: settings?.bgRepeat || undefined,
		backgroundAttachment: settings?.bgAttachment || undefined,
		color: settings?.fontColor || undefined,
	};

	return style;
};

//** cookie */
export const getCookieData = (key: string) => {
	const data = Cookies.get(key);
	return data ? jsonParseSafe(data) : null;
};

export const setCookieData = (key: string, data: any) => {
	Cookies.set(key, JSON.stringify(data), { domain: envs.domain });
};

//** token */
export {
	getTokenCookie,
	removeTokenCookie,
	setTokenCookie,
} from "./token-cookie";

// ** Guest User ID ** //

// get local storage data
export const getLocalStorageData = (key: string): any => {
	return JSON.parse(localStorage.getItem(key) || "{}");
};

// set local storage data
export const setLocalStorageData = (key: string, data: any) => {
	localStorage.setItem(key, JSON.stringify(data));
};

// ** google maps


export function changeLocation({
	map,
	location,
	animationDuration = 1000,
}: {
	map: google.maps.Map;
	location: google.maps.LatLng;
	animationDuration?: number;
}) {
	const newLocation = {
		lat: location.lat() + getLatValueFromMeter(markerYOffset),
		lng: location.lng(),
	}; // New location
	const distance = distanceBetweenCords(
		map.getCenter()?.lat() || 0,
		map.getCenter()?.lng() || 0,
		newLocation.lat,
		newLocation.lng
	);

	const duration = 1000 + distance * 100;

	const start = performance.now();
	const startLocation = map.getCenter();
	const startZoom = map.getZoom();
	const zoomAmount = 0.05;
	const halfTime = duration / 2;

	function animate() {
		const elapsed = performance.now() - start;

		if (elapsed < duration && startLocation && startZoom) {
			const t = elapsed / duration;
			const lat =
				startLocation.lat() +
				(newLocation.lat - startLocation.lat()) * t;
			const lng =
				startLocation.lng() +
				(newLocation.lng - startLocation.lng()) * t;

			// zoom out then to startZoom animate
			let zoom = 0;

			if (elapsed < halfTime) {
				const t = elapsed / halfTime;
				zoom = startZoom - (startZoom - zoomAmount) * t;
			} else {
				const t = (elapsed - halfTime) / halfTime;
				zoom = zoomAmount + (startZoom - zoomAmount) * t;
			}

			// map.panTo({ lat, lng });
			map.setCenter({ lat: lat, lng });

			requestAnimationFrame(animate);
		} else {
			map.panTo(newLocation);
		}
	}

	requestAnimationFrame(animate);
}

export function distanceBetweenCords(
	lat1: number,
	lon1: number,
	lat2: number,
	lon2: number
) {
	const earthRadius = 6371; // Earth's radius in kilometers (or 3959 miles)

	// Convert latitude and longitude from degrees to radians
	const lat1Rad = (Math.PI * lat1) / 180;
	const lon1Rad = (Math.PI * lon1) / 180;
	const lat2Rad = (Math.PI * lat2) / 180;
	const lon2Rad = (Math.PI * lon2) / 180;

	// Haversine formula
	const dLat = lat2Rad - lat1Rad;
	const dLon = lon2Rad - lon1Rad;
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(lat1Rad) *
			Math.cos(lat2Rad) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	const distance = earthRadius * c;

	return distance; // Distance in kilometers (or miles if Earth's radius is in miles)
}

export function distanceB2NCordsInMeters(
	lat1: number,
	lon1: number,
	lat2: number,
	lon2: number
) {
	const earthRadius = 6371000; // Earth's radius in meters

	// Convert latitude and longitude from degrees to radians
	const lat1Rad = (Math.PI * lat1) / 180;
	const lon1Rad = (Math.PI * lon1) / 180;
	const lat2Rad = (Math.PI * lat2) / 180;
	const lon2Rad = (Math.PI * lon2) / 180;

	// Haversine formula
	const dLat = lat2Rad - lat1Rad;
	const dLon = lon2Rad - lon1Rad;
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(lat1Rad) *
			Math.cos(lat2Rad) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	const distance = earthRadius * c;

	return distance; // Distance in meters
}

export const getClientCurrentLocation = (): Promise<google.maps.LatLng> =>
	new Promise((resolve, reject) => {
		if ("geolocation" in navigator) {
			// Geolocation is available

			navigator.geolocation.getCurrentPosition(
				function (position) {
					const latitude = position.coords.latitude;
					const longitude = position.coords.longitude;
					const latLng = new google.maps.LatLng(latitude, longitude);

					resolve(latLng);
				},
				function (error) {
					switch (error.code) {
						case error.PERMISSION_DENIED:
							// console.log("User denied the request for Geolocation.");
							break;
						case error.POSITION_UNAVAILABLE:
							// console.log("Location information is unavailable.");
							break;
						case error.TIMEOUT:
							// console.log("The request to get user location timed out.");
							break;
						default:
							// console.log("An unknown error occurred.");
							break;
					}

					reject("Geolocation is not supported by this browser.");
				},
				{ maximumAge: 0 }
			);
		} else {
			reject("Geolocation is not supported by this browser.");
		}
	});

export const getLatValueFromMeter = (meter: number) => {
	return meter / 111111;
};

export const textLetterLimit = (text: string, limit: number) => {
	if (text.length > limit) {
		return text.slice(0, limit) + "...";
	} else {
		return text;
	}
};

type Procedure = (...args: any[]) => void;

export function debounce<F extends Procedure>(
	func: F,
	delay: number
): (...args: Parameters<F>) => void {
	let timeout: ReturnType<typeof setTimeout>;

	return function (this: unknown, ...args: Parameters<F>) {
		const context = this as any;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), delay);
	};
}

export const getImageArray = (image?: string) => {
	if (!image) return [];
	return image.split(",");
};

export function convertNameChar(str: string) {
	return str
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&quot;/g, '"')
		.replace(/&#039;/g, "'")
		.replace(/&amp;/g, "&");
}

export function shuffleArray(array: any[]) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
}

export const toCartAnimation = () => {
	const image = document.getElementById(productImageId) as HTMLDivElement;

	const floatingCart = document.getElementById(
		cartButtonId
	) as HTMLDivElement;

	if (!image || !floatingCart) return;

	const newImage = image.cloneNode(true) as HTMLDivElement;

	const rect = image.getBoundingClientRect();
	const rect2 = floatingCart.getBoundingClientRect();

	newImage.style.position = "fixed";
	newImage.style.top = rect.top + "px";
	newImage.style.left = rect.left + "px";
	newImage.style.width = rect.width + "px";
	newImage.style.height = rect.height + "px";
	newImage.style.zIndex = "1000";
	newImage.style.transition = "all .5s ease-in";

	document.body.appendChild(newImage);

	setTimeout(() => {
		newImage.style.top = rect2.top + "px";
		newImage.style.left = rect2.left + "px";
		newImage.style.width = rect2.width + "px";
		newImage.style.height = rect2.height + "px";
	}, 100);

	setTimeout(() => {
		newImage.remove();
	}, 600);
};

export const jsonParseSafe = (data: string) => {
	try {
		return JSON.parse(data);
	} catch (error) {
		return undefined;
	}
};

export const randomUserId = (): number => {
	return Date.now() + Math.floor(Math.random() * 100);
};

// change all 'font-size SIZE' in 'font-size: min(max(1rem, 3vw), SIZE)'
export const convertFontSize = (htmlContent: string) => {
	return htmlContent.replace(
		/font-size:(\d+)px/g,
		"font-size: min(max(0.9rem, 4vw), $1px)"
	);
};

export function replaceSlash(str: string) {
	return str.toString().replace("/", "&sol;");
}

export function addSlash(str: string | string[]) {
	return str.toString().replace(/&sol;/g, "/");
}

export const handleUrlRedirection = async (
	ctx: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>
) => {
	const url =
		(process.env.NEXT_PUBLIC_HOME_PAGE_URL || "") +
		(ctx.resolvedUrl?.startsWith("/")
			? ctx.resolvedUrl.slice(1)
			: ctx.resolvedUrl);

	try {
		const res = await getRedirectUrl(url);

		return {
			redirect: {
				destination: res.data,
				permanent: false,
			},
		};
	} catch (error) {}
};

/**
 * Removes or replaces characters that would be problematic in HTML elements
 * @param {string} str - The input string to sanitize
 * @return {string} - The sanitized string safe for HTML insertion
 */
export function sanitizeForHTML(str: string): string {
	// Check if the input is a string, if not return an empty string
	if (!str) return "";

	return String(str)
		.replaceAll(/&/g, "&amp;") // Replace & with &amp;
		.replaceAll(/</g, "&lt;") // Replace < with &lt;
		.replaceAll(/>/g, "&gt;") // Replace > with &gt;
		.replaceAll(/"/g, "&quot;") // Replace " with &quot;
		.replaceAll(/'/g, "&#39;") // Replace ' with &#39;
		.replaceAll(/\//g, "&#x2F;") // Replace / with &#x2F;
		.replaceAll(/\\/g, "&#x5C;") // Replace \ with &#x5C;
		.replaceAll(/`/g, "&#96;"); // Replace ` with &#96;
}



export function jsonDecodeSafe<T>(data: string): T | undefined {
	try {
		return JSON.parse(data) as T;
	} catch (error) {
		return undefined;
	}
}

export const decodeToken = (token: string) => {
	try {
		const decoded = jwtDecode(token) as any;	
		return decoded;
	} catch (error) {
		return null;
	}
}
